import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';

const AutoCompleteFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const Province = props => (
    <List filters={<AutoCompleteFilter/>} {...props} exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="name"/>
        </Datagrid>
    </List>
);

export default Province
